const loc = window.location.href;

let path = "https://test-api.icelandair.is/api/maintener-backend"
if (loc.includes("localhost")) { path = "https://localhost:44302" }
if (loc.includes("maintener.icelandair.is")) { path = "https://api.icelandair.is/api/maintener-backend" }
if (loc.includes("maintener-frontend.stage")) { path = "https://api.icelandair.is/api/maintener-backend-training" }

export const settings = {
    HOST: path,
    KONG_KEY: process.env.REACT_APP_MAINTENER_BACKEND_API_KEY !== undefined ? process.env.REACT_APP_MAINTENER_BACKEND_API_KEY : '',
};